import React from 'react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  showPaymentMethods?: boolean;
  scrollTo?: string;
}
export function CTAButton({
  href,
  children,
  className = '',
  showPaymentMethods = false,
  scrollTo
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const target = document.getElementById(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <div data-id="element-68">
      <a href={href} onClick={handleClick} className={`block bg-gradient-to-br from-brand-orange to-brand-darkOrange text-white py-5 px-8 md:px-10 rounded-lg font-oswald text-lg md:text-2xl font-bold uppercase tracking-wide text-center mx-auto max-w-[600px] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(255,87,51,0.6)] animate-glow cursor-pointer ${className}`} data-id="element-69">
        {children}
      </a>
      {showPaymentMethods && <div className="flex justify-center mt-4" data-id="element-70">
          <img src="https://cdn.magicpatterns.com/uploads/dq7N7sGyJSBJfbNWsR1YxL/descarga.png" alt="Visa, Mastercard, MercadoPago" className="h-8 md:h-10 w-auto object-contain opacity-80" data-id="element-71" />
        </div>}
    </div>;
}